"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChunkContentWithEmbeddingSchema = exports.ChunkContentSchema = void 0;
const zod_1 = require("zod");
exports.ChunkContentSchema = zod_1.z.object({
    chunkId: zod_1.z.string(),
    textContent: zod_1.z.string(),
    chunkIndex: zod_1.z.number(),
    metadata: zod_1.z.record(zod_1.z.string(), zod_1.z.unknown()).optional(),
});
exports.ChunkContentWithEmbeddingSchema = exports.ChunkContentSchema.extend({
    embedding: zod_1.z.array(zod_1.z.number()),
});
//# sourceMappingURL=chunks.js.map